import { LANGUAGE_CODES } from '@constants/countryDetails'
import { APP_FEATURES } from '@constants/features'
import type { AppLocales } from '@constants/i18n'
import { arrayIncludes } from '@helpers/arrayIncludes'
import { getCountryLanguageFromLocale } from '@helpers/getCountryLanguageFromLocale'

export const getFullUrlForFeature = (
  locale: AppLocales,
  slug: string,
  feature: keyof typeof APP_FEATURES
) => {
  const { language: languageString } = getCountryLanguageFromLocale(locale)
  const language = arrayIncludes(LANGUAGE_CODES, languageString)
    ? languageString
    : null

  const prefix = language ? APP_FEATURES[feature].prefix[language] : null
  const fullUrl = language && slug ? `/${locale}${prefix}/${slug}` : null

  return fullUrl
}
